import FirebaseAnalytics from '@shamrock-core/common/analytics/firebase-analytics';

type FireBaseModules = typeof FirebaseAnalytics.MODULES;
type FireBasePages = typeof FirebaseAnalytics.PAGES;
type FireBaseLabels = typeof FirebaseAnalytics.LABELS;
type FireBaseEvents = typeof FirebaseAnalytics.EVENTS;

class Analytics extends FirebaseAnalytics {
  static get MODULES(): FireBaseModules {
    return {
      ...super.MODULES,
      FACTORING: 'Factoring',
      FREIGHT: 'Freight',
      PRODUCT_TEASERS: 'Product Teasers',
      BANKING: 'Banking',
    };
  }

  static get PAGES(): FireBasePages {
    return {
      ...super.PAGES,
      MAIN_NAVIGATION: 'Main Navigation',
      TOP_MENU: 'Top Menu',
      FACTORING_PRODUCT_TEASER: 'factoringWebProductTeaser',
      FREIGHT_PRODUCT_TEASER: 'freightWebProductTeaser',
      FUEL_PRODUCT_TEASER: 'fuelWebProductTeaser',
      CREDIT_PRODUCT_TEASER: 'creditWebProductTeaser',
      LOAD_MANAGEMENT_PRODUCT_TEASER: 'loadManagementWebProductTeaser',
      OUR_SERVICES: 'Our Services Web',
      RMIS_APP_PAGE: 'rmisMobileAppPage',
      SETTINGS: 'Settings',
      ADD_REMOVE_ACCOUNTS: 'addRemove',
      VIEW_CUSTOMER: 'viewCustomer',
      ANY: 'Any',
      SELECT_PLAN: 'Select Plan',
      ENTER_PAYMENT_INFORMATION: 'Enter Payment Information',
    };
  }

  static get LABELS(): FireBaseLabels {
    return {
      ...super.LABELS,
      ERROR: 'Error',
      ADMINISTRATION: 'Administration',
      API_KEYS: 'Api Keys',
      BANK_INFORMATION: 'Bank Information',
      CONTACT_US: 'Contact Us',
      QUOTING_ADMIN: 'Quoting Admin',
      DELETE_ACCOUNT: 'Delete Account',
      PHONE_NUMBER: 'Phone Number',
      PROFILE_ACCOUNT: 'Profile Account',
      EDITION_MY_REWARDS: 'Add/Edit myRewards Number',
      EDITION_ACCOUNT_INFO: 'Edit Account Info',
      SELECTED_MANAGE_USERS: 'Manage Users Tile Selected',
      CANCEL_DELETE_ACCOUNT: 'Cancel Delete Acct Request',
      CONFIRM_DELETE_ACCOUNT: 'Confirms Delete Acct Request',
      ADD_DRIVER_ID: 'Add Driver ID',
      ADD_MY_REWARDS_NUMBER: 'Add myRewards Number',
      SETTINGS: 'Settings Page',
    };
  }

  static get PARAMETERS(): FireBaseLabels {
    return {
      ...super.PARAMETERS,
      RESOLUTION: 'Resolution',
      DATETIMESTAMP: 'DateTimestamp',
      BROWSER_TYPE: 'Browser Type',
      USER_IP: 'User Ip',
    };
  }

  static get EVENTS(): FireBaseEvents {
    return {
      ...super.EVENTS,
      EDIT: 'Edit',
      ADD: 'Add',
    };
  }
}

export default Analytics;
